type Section = { title: string; description: string };

const normalizeSetextToAtx = (input: string): string => {
  const src = input.split(/\r?\n/);
  const out: string[] = [];
  for (let i = 0; i < src.length; i++) {
    const line = src[i];
    const next = src[i + 1];
    if (next && /^\s*=+\s*$/.test(next)) {
      out.push(`# ${line.trim()}`);
      i += 1; // skip underline
      continue;
    }
    if (next && /^\s*-+\s*$/.test(next)) {
      out.push(`## ${line.trim()}`);
      i += 1; // skip underline
      continue;
    }
    out.push(line);
  }
  return out.join('\n');
};

export const parseMarkdownSections = (markdown: string): Section[] => {
  // 1) Normalize Setext H1/H2 into ATX form for simpler parsing
  const text = normalizeSetextToAtx(markdown);
  const lines = text.split(/\r?\n/);

  const sections: Section[] = [];
  let inCodeBlock = false;
  let title: string | null = null;
  let buffer: string[] = [];

  const flush = () => {
    const content = buffer.join('\n').trim();
    if (content) sections.push({ title: title ?? 'Instructions', description: content });
    title = null;
    buffer = [];
  };

  for (const line of lines) {
    const trimmed = line.trim();

    // Toggle fenced code blocks; do not split while inside
    if (trimmed.startsWith('```')) {
      inCodeBlock = !inCodeBlock;
      buffer.push(line);
      continue;
    }

    if (!inCodeBlock) {
      const m = line.match(/^(#{1,2})\s+(.+?)\s*#*\s*$/);
      if (m) {
        flush();
        title = m[2].trim();
        continue;
      }
    }

    buffer.push(line);
  }

  flush();

  if (sections.length === 0 && markdown.trim()) {
    return [{ title: 'Instructions', description: markdown.trim() }];
  }
  return sections;
};
